module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sessao-questionnaire"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "list-alt"
    }
  }), _vm._v(" Avaliação de riscos")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.storage_material),
      expression: "questionnaire.storage_material"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.storage_material"
    },
    domProps: {
      "checked": _vm.storage_material,
      "checked": Array.isArray(_vm.questionnaire.storage_material) ? _vm._i(_vm.questionnaire.storage_material, null) > -1 : (_vm.questionnaire.storage_material)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.storage_material,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.storage_material = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.storage_material = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "storage_material", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Local utilizado exclusivamente para depósito de materiais")])])]), _vm._v(" "), (_vm.errors.has('data.residence.storage_material')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.storage_material')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.boxes_electronics),
      expression: "questionnaire.boxes_electronics"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.boxes_electronics'"
    },
    domProps: {
      "checked": _vm.boxes_electronics,
      "checked": Array.isArray(_vm.questionnaire.boxes_electronics) ? _vm._i(_vm.questionnaire.boxes_electronics, null) > -1 : (_vm.questionnaire.boxes_electronics)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.boxes_electronics,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.boxes_electronics = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.boxes_electronics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "boxes_electronics", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel possui caixas eletrônicos em suas dependências")])])]), _vm._v(" "), (_vm.errors.has('data.residence.boxes_electronics')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.boxes_electronics')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.wasted_currency),
      expression: "questionnaire.wasted_currency"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.wasted_currency"
    },
    domProps: {
      "checked": _vm.wasted_currency,
      "checked": Array.isArray(_vm.questionnaire.wasted_currency) ? _vm._i(_vm.questionnaire.wasted_currency, null) > -1 : (_vm.questionnaire.wasted_currency)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.wasted_currency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.wasted_currency = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.wasted_currency = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "wasted_currency", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel faz divisa com terreno baldio")])])]), _vm._v(" "), (_vm.errors.has('data.residence.wasted_currency')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.wasted_currency')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.isopainel),
      expression: "questionnaire.isopainel"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.isopainel"
    },
    domProps: {
      "checked": _vm.isopainel,
      "checked": Array.isArray(_vm.questionnaire.isopainel) ? _vm._i(_vm.questionnaire.isopainel, null) > -1 : (_vm.questionnaire.isopainel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.isopainel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.isopainel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.isopainel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "isopainel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel possui Isopainel em sua construção")])])]), _vm._v(" "), (_vm.errors.has('data.residence.isopainel')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.isopainel')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.historical_heritage),
      expression: "questionnaire.historical_heritage"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.historical_heritage"
    },
    domProps: {
      "checked": _vm.historical_heritage,
      "checked": Array.isArray(_vm.questionnaire.historical_heritage) ? _vm._i(_vm.questionnaire.historical_heritage, null) > -1 : (_vm.questionnaire.historical_heritage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.historical_heritage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.historical_heritage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.historical_heritage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "historical_heritage", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel tombado pelo patrimônio histórico")])])]), _vm._v(" "), (_vm.errors.has('data.residence.historical_heritage')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.historical_heritage')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.construction_renovation),
      expression: "questionnaire.construction_renovation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "data.residence.construction_renovation"
    },
    domProps: {
      "checked": _vm.construction_renovation,
      "checked": Array.isArray(_vm.questionnaire.construction_renovation) ? _vm._i(_vm.questionnaire.construction_renovation, null) > -1 : (_vm.questionnaire.construction_renovation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.construction_renovation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.construction_renovation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.construction_renovation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "construction_renovation", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel em construção ou reforma")])])]), _vm._v(" "), (_vm.errors.has('data.residence.construction_renovation')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.construction_renovation')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionnaire.metal_structure),
      expression: "questionnaire.metal_structure"
    }],
    attrs: {
      "type": "checkbox",
      "id": "metal_structure"
    },
    domProps: {
      "checked": _vm.metal_structure,
      "checked": Array.isArray(_vm.questionnaire.metal_structure) ? _vm._i(_vm.questionnaire.metal_structure, null) > -1 : (_vm.questionnaire.metal_structure)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questionnaire.metal_structure,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.questionnaire.metal_structure = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.questionnaire.metal_structure = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.questionnaire, "metal_structure", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Imóvel possui telhado e/ou estrutura feita de metal")])])]), _vm._v(" "), (_vm.errors.has('data.residence.metal_structure')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.metal_structure')))]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f24376","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Questionnaire/FormPartialQuestionnaire.vue
// module id = 343
// module chunks = 0